// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"333":"74cce6a9896c823a","888":"55d7f510fae3309f"}[chunkId] + ".css";
};